import styled from 'styled-components';

export const WidgetPreviewRenderWrapper = styled.div`
  position: relative;
  transition: all 0.3s ease-in-out;
  /* max-height: 1000px; */
  border-bottom: 0px solid ${props => props.theme.colorWarning};

  &.compact {
    max-height: ${props => props.theme.compactWidgetHeight}px;
    overflow-y: hidden;
    border-bottom: 2px solid ${props => props.theme.colorWarning};
  }
`;
